// extracted by mini-css-extract-plugin
export default {"clearAll":"BFilterSelectedGroups-module_clearAll_e2391057"};